module.exports = __webpack_public_path__ + "static/media/Fichier 19.4c66c2d3.svg";